import { ValidationErrors, AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

// ----------- define ansynchrous validation functions ---------------
export function asyncRequired(delayTime: number):  AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      let fieldValue: string = control.value as string;
      let whitespaceRegExp = new RegExp(/\s+/g);
      return new Promise(resolve => {
        setTimeout(() => {
          if (fieldValue === null || fieldValue === undefined || whitespaceRegExp.test(fieldValue)) {
            resolve({ required: true}) ;
          } else {
            resolve(null);
          }
        }, delayTime);
      });
    };
  }

export function asyncPattern(regExp: RegExp, delayTime: number):  AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      let fieldValue: string = control.value as string;
      return new Promise(resolve => {
        setTimeout(() => {
          if (fieldValue !== null && fieldValue !== undefined
             && !regExp.test(fieldValue)) {
            resolve({pattern: true});
          } else {
            resolve(null);
          }
        }, delayTime);
      });
    };
  }

export function asyncMaxInt(maxValue: number, delayTime: number):  AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      let fieldValue = control.value;
      return new Promise(resolve => {
        setTimeout(() => {
          if ((fieldValue === null || fieldValue === undefined)
             && Number.isInteger(fieldValue)
             && Number.parseInt(fieldValue) > maxValue) {
            resolve({ max: true}) ;
          } else {
            resolve(null);
          }
        }, delayTime);
      });
    };
  }

export function asyncMinInt(minValue: number, delayTime: number):  AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      let fieldValue = control.value;
      return new Promise(resolve => {
        setTimeout(() => {
          if (!(fieldValue === null || fieldValue === undefined)
             && Number.isInteger(fieldValue)
             && Number.parseInt(fieldValue) < minValue) {
            resolve({ max: true}) ;
          } else {
            resolve(null);
          }
        }, delayTime);
      });
    };
  }

  export function asyncFromGreater(fromControlName: string, toControlName: string, timeDelay: number):  AsyncValidatorFn {
    return (formGroup: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      const fromControl: AbstractControl = formGroup.get(fromControlName);
      const toControl: AbstractControl = formGroup.get(toControlName);
      return new Promise(resolve => {
        setTimeout(() => {
          if (fromControl && toControl && fromControl.value && toControl.value
             && (fromControl.value > toControl.value)) {
             return resolve({ fromGreater: true}) ;
          } else {
            resolve(null);
          }
        }, timeDelay);
      });
    };
  }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/field-validators.ts